import ServiceDetailPage from '../components/services/ServiceDetailPage';
import { getServicePageConfig } from '../data/services/servicesRegistry';

const CustomPackagingService = () => (
  <ServiceDetailPage {...getServicePageConfig('customPackaging')} />
);

export default CustomPackagingService;
